export const _initialState = {
  productData: null,
  fetchedSkus: []
};
